import { BaseApi } from '@/main/baseApi';
import { Zakazka } from '@/modules/servis/zakazka';

import { DMS_MODULE, NAME } from './constants';

class MontazDvProvider extends BaseApi {
	tableSchema() {
		return this.fetch(`/${DMS_MODULE}/${Zakazka.name}/${NAME}Schema`);
	}

	tableData(filter: any) {
		return this.fetch(`/${DMS_MODULE}/${Zakazka.name}/${NAME}Rows`, filter);
	}
}

export const apiProvider = new MontazDvProvider(DMS_MODULE, NAME);
